import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'jalali-moment';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ContestsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('contests'), link: '/contests-list' },
		{ title: t('list') }
	];

	const [contests, setContests] = useState([]);
	let contestsListData = {
		head: [t('title'), t('start_date'), t('end_date'), t('status')],
		body: contests.map(contest => [
			contest.contest_name,
			moment(contest.contest_start_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			moment(contest.contest_end_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			<span className={"badge rounded-pill p-2 badge-subtle-" + (contest.is_active ? 'success' : 'secondary')}>
				{contest.is_active ? t('active') : t('deactive')}
			</span>
		]),
		directions: ['rtl', 'ltr', 'ltr', '', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchContestTitle, setSearchContestTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getContests = async () => {
		let body = {
			contest_name: searchContestTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/contests/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_contests);
				setContests(response.data.contests);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterContests = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchContestTitle.value.trim() || null;
		setSearchContestTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getContests();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('contests')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterContests}>
						<div className="row gx-2">
							<FormField fieldKey="searchContestTitle" title={t('title')} value={searchContestTitle} isSearch={true} rtl />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('contests')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={contestsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ContestsList;
